import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faCalendarDays } from "@fortawesome/free-solid-svg-icons";

const CssTextField = styled(TextField)({
    "& .MuiInputLabel-root": {
        fontSize: "12px",
        color: "#666",
        backgroundColor: "#fff",
        top: "6px",
        "& .required": {
            color: "#f00",
            paddingLeft: "2px",
            fontSize: "12px",
        },
    },
    "& label.MuiInputLabel-shrink": {
        top: "2px", // Move label up when input has a value
    },
    "& label.Mui-focused": {
        color: "#ff7100",
        top: "0px",

    },
    "& .Mui-disabled": {
        color: "#666 !important",
    },
    "& .MuiInput-underline:after": {
        borderBottomColor: "#ff7100",
    },
    '& .MuiOutlinedInput-input': {
        padding: '16px 14px',
    },
    "& .MuiOutlinedInput-root": {
        backgroundColor: "#fff",
        height: "52px",
        paddingLeft: '0px !important',

        "& fieldset": {
            borderColor: "#a6a8ab",
        },
        "&:hover fieldset": {
            borderColor: "#a6a8ab",
        },
        "&.Mui-focused fieldset": {
            borderColor: "#ff7100",

        },

        "& input[type=number]": {
            MozAppearance: "textfield",
            padding: "9px 9px",
        },
        "& input[type=number]::-webkit-outer-spin-button": {
            WebkitAppearance: "none",
            margin: 0,
        },
        "& input[type=number]::-webkit-inner-spin-button": {
            WebkitAppearance: "none",
            margin: 0,
        },
    },
});

function TextBox(props) {
    const {
        type,
        label = "",
        value = "",
        onChange = null,
        disabled = false,
        name,
        isCompulsory = false,
        calIcon = false,
        rssign = false,
        textBoxRef,
        adornment,
        style,
        onBlur = null,
        maxLength = "",
        autoFocus = false,
        onKeyDown,
        isSpecficText = false,
        regePattern = "",
        id = '',
        variant = 'outlined'
    } = props;

    const [inputValue, setInputValue] = useState(value);

    useEffect(() => {
        // Focus on the text field if autoFocus is true
        if (autoFocus && textBoxRef && textBoxRef.current) {
            textBoxRef.current.focus();
        }
    }, [autoFocus, textBoxRef]);
    useEffect(() => {
        if (value !== inputValue) {
            setInputValue(value);
        }
    }, [value]);

    const handleInputOnChange = (e) => {
        let newVal = e.target.value;
        if (isSpecficText && regePattern !== '') {
            let checkText = new RegExp(regePattern);
            if (checkText.test(newVal)) {
                handleValue(e, newVal)
            }
        } else {
            handleValue(e, newVal)
        }

    };
    const handleValue = (e, newVal) => {
        if (maxLength) {
            if (newVal.length <= maxLength) {
                setInputValue(newVal);
                if (onChange) {
                    const syntheticEvent = {
                        target: {
                            value: newVal,
                            name: e.target.name,
                        },
                    };
                    onChange(syntheticEvent, newVal);
                }
            }
        } else {
            setInputValue(newVal);
            if (onChange) {
                const syntheticEvent = {
                    target: {
                        value: newVal,
                        name: e.target.name,
                    },
                };
                onChange(syntheticEvent, newVal);
            }
        }
    }
    const handleInputOnBlur = (e) => {
        let newVal = e.target.value;
        if (isSpecficText && regePattern !== '') {
            let checkText = new RegExp(regePattern);
            if (checkText.test(newVal)) {
                setInputValue(newVal);
                if (onBlur) {
                    const syntheticEvent = {
                        target: {
                            value: newVal,
                            name: e.target.name,
                        },
                    };
                    onBlur(syntheticEvent, newVal);
                }
            }
        } else {
            setInputValue(newVal);
            if (onBlur) {
                const syntheticEvent = {
                    target: {
                        value: newVal,
                        name: e.target.name,
                    },
                };
                onBlur(syntheticEvent, newVal);
            }
        }
    };

    const labelTxt = isCompulsory ? (
        <span>
            {label}
            <span style={{ color: "red", paddingLeft: "5px" }}>*</span>
        </span>
    ) : (
        label
    );

    const clearInput = (e) => {
        setInputValue("");
        if (onChange) {
            onChange(e);
        }
    };

    const handleWheel = (e) => {
        if (type === "number") {
            e.preventDefault();
            e.target.blur();
        }
    };

    return (
        <CssTextField
            fullWidth
            type={type}
            name={name}
            id={id === '' ? name : id}
            label={labelTxt}
            disabled={disabled}
            value={inputValue}
            onChange={handleInputOnChange}
            size="small"
            inputRef={textBoxRef}
            sx={style}
            variant={variant}
            onBlur={handleInputOnBlur}
            onKeyDown={(e) => {
                onKeyDown && onKeyDown(e);
            }}
            onWheel={handleWheel} // Add event listener to prevent mouse wheel behavior
            InputProps={{
                autoComplete: "off",
                startAdornment: adornment ? (
                    calIcon ? (
                        <InputAdornment position="start">
                            <FontAwesomeIcon
                                icon={faCalendarDays}
                                className="cross"
                                style={{ fontSize: "12px" }}
                                color={"#0085fe"}
                            />
                        </InputAdornment>
                    ) : rssign ? (
                        "Rs"
                    ) : null
                ) : null,
                endAdornment: adornment ? (
                    disabled ? null : (
                        <InputAdornment position="end">
                            {inputValue && inputValue.length > 0 && (
                                <div className="cross--icon">
                                    <FontAwesomeIcon
                                        icon={faXmark}
                                        className="cross"
                                        onClick={clearInput}
                                    />
                                </div>
                            )}
                        </InputAdornment>
                    )
                ) : null,
            }}
            inputProps={
                type === "number" ? { max: maxLength } : { maxLength: maxLength }
            }
        />
    );
}

export default TextBox;
